import clsx from 'clsx';
import { useTemplatesSearchField } from '../../../../features/templates/ui/lib/useTemplatesSearchField';
import styles from './TemplatesList.module.css';
import { TemplatesToolbar } from './components/TemplatesToolbar';
import { TemplatesCardsGrid } from './components/TemplatesCardsGrid';
import { TemplatesPaginationRow } from './components/TemplatesPaginationRow';
import { TemplatesSortRow } from './components/TemplatesSortRow';
import { NoResultsEmptyState } from './NoResultsEmptyState';

export function TemplatesList({
  items,
  showCardsSpinner = false,
  page,
  pageSize,
  totalPages,
  onPageChange,
  onPageSizeChange,
  onCreateTemplate,
  onEditTemplate,
  onCopyTemplate,
  onPreviewTemplate,
  canEdit = false,
}) {
  const { value: searchValue, setValue: setSearchValue, clear } = useTemplatesSearchField();

  return (
    <section className={clsx(styles.main)} aria-label="Templates list">
      <TemplatesToolbar
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        onSearchClear={clear}
        onCreateTemplate={onCreateTemplate}
      />

      <TemplatesSortRow />

      {items.length === 0 && !showCardsSpinner ? (
        <NoResultsEmptyState />
      ) : (
        <TemplatesCardsGrid
          items={items}
          showSpinner={showCardsSpinner}
          onEditTemplate={onEditTemplate}
          onCopyTemplate={onCopyTemplate}
          onPreviewTemplate={onPreviewTemplate}
          canEdit={canEdit}
        />
      )}

      <TemplatesPaginationRow
        itemsLength={items.length}
        page={page}
        pageSize={pageSize}
        totalPages={totalPages}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
      />
    </section>
  );
}
